import { PromptQuestionCircleFill } from "@/Icons";
import { Tooltip } from "@ad/anq-ui";
import React, { ReactNode } from "react";

export type TooltipType = "underline" | "question" | "none";

interface Props {
  title?: ReactNode;
  tooltip?: ReactNode;
  type?: TooltipType;
}

const TooltipTitle = ({ title, tooltip, type = "question" }: Props) => {
  if (type === "question") {
    return (
      <div className="flex items-center">
        <span>{title}</span>
        <Tooltip title={tooltip}>
          <PromptQuestionCircleFill className="ml-1 cursor-pointer text-[16px] text-question" />
        </Tooltip>
      </div>
    );
  }

  if (type === "none") {
    return <Tooltip title={tooltip}>{title}</Tooltip>;
  }

  return (
    <Tooltip title={tooltip}>
      <span className="inline-block border-b border-dotted border-text-black-base">
        {title}
      </span>
    </Tooltip>
  );
};

export default TooltipTitle;
